<ng-container *ngIf="isLoading$ | async">
  <div class="progress progress-modal">
    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
      style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</ng-container>
<div class="card card-custom gutter-b" style="margin-bottom: 20px;">
  <div class="card-header">
    <div class="card-title">
      <h4 class="card-label" style="margin: 15px;font-weight: bold;">
        {{'APPOINTMENTS.ADD.SPECIALTY' | translate}}
      </h4>
    </div>
  </div>
  <div class="doctor-search-area">
    <div class="container">
        <form>
            <div class="row doctor-search-wrap">
                <div class="col-sm-3 col-lg-3"></div>
                <div class="col-sm-6 col-lg-6">
                    <div class="doctor-search-item">
                        <div class="form-group">
                          <i class="icofont-navigation-menu"></i>
                            <label style="font-weight: bold;">{{'APPOINTMENTS.ADD.SPECIALTY' | translate}}</label>
                            <ng-select (change)="OnChangeSpecialty($event)" (search)="OnSearchSpecialty($event)" 
                            [notFoundText]="language == 'en'? 'No results': 'لا توجد نتائج'">
                              <ng-option *ngFor="let Specialty of HospitalSpecialties$" [value]="Specialty.departmentId">
                                {{ language == 'en'?Specialty.departmentName: Specialty.departmentNameArabic }}</ng-option>
                           </ng-select>

                            <!-- <ng-select formControlName="CompanyId" class="ng-select" [items]="HospitalSpecialties$" bindLabel="departmentNameArabic"
                              bindValue="id" notFoundText="لا توجد نتائج للبحث" (search)="OnSearchSpecialty($event)" >
                            </ng-select> -->

                            <!-- <select class="form-control" (change)="OnChangeSpecialty($event)"
                                *ngIf="HospitalSpecialties$ | async as HospitalSpecialties ;else EmptyHospitalSpecialties">
                                <option value=0>{{'COMMON.SELECT' | translate}}</option>
                                <option value={{Specialty.departmentId}}
                                    *ngFor="let Specialty of HospitalSpecialties">{{ language == 'en'?
                                    Specialty.departmentName: Specialty.departmentNameArabic }}</option>
                            </select>
                            <ng-template #EmptyHospitalSpecialties>
                                <select class="form-control">
                                    <option value=0>{{'COMMON.SELECT' | translate}}</option>
                                </select>
                            </ng-template> -->
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div> 
  <div class="card-body">
    <section class="departments-area" style="padding-top: 30px !important;">
      <div class="container">
        <div class="row">
          <div *ngFor="let Doctor of SpecialtyDoctors;let i = index"
            class="col-lg-4 col-md-12  wow animate__animated animate__fadeInUp" data-wow-delay=".3s" >
                <div class="doctor-item row" style="padding: 15px;margin: 0px 1px 20px 1px;;height: 270px;">
                    <div class="col-lg-3 docimg" style="margin-bottom: 15px;">
                        <img *ngIf="Doctor.picPath != null;else NoDocPic" [src]="Doctor.picPath | SafeImgUrlPipe" alt="Doctor">
                        <ng-template #NoDocPic><img src="assets/img/doctor/Avatar.png" alt="Doctor"></ng-template>
                    </div>
                    
                    <div class="col-lg-2 flagimg">
                      <img *ngIf="Doctor.apiNationality?.flagPath != null;" [title]="language == 'en'? Doctor.apiNationality?.countryNameEn : Doctor.apiNationality?.countryNameAr"
                          [src]="Doctor.apiNationality?.flagPath | SafeImgUrlPipe" [alt]="language == 'en' ? Doctor.apiNationality?.countryNameEn : Doctor.apiNationality?.countryNameAr">
                     <!-- <img src="assets/img/home-one/1.png" alt="Doctor" [title]="language == 'en'? Doctor.apiNationality?.countryNameEn : Doctor.apiNationality?.countryNameAr"> -->
                  </div>
                    <div class="col-lg-12 docinfo" style="height: 120px;">
                      <h5 >
                        {{ language == 'en'? 'Dr. '+ Doctor.employee?.firstName +' '+ Doctor.employee?.newLastname
                        : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rLastName }}</h5>
                        <!-- <h5 >
                            {{ language == 'en'? 'Dr. '+ Doctor.employee?.firstName +' ' + Doctor.employee?.middleName +' '+ Doctor.employee?.newLastname
                            : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rMiddleName+' '+ Doctor.employee?.rLastName }}</h5> -->
                            <label>{{ language == 'en' ? Doctor.titleEn : Doctor.titleAr }}</label><br>
                            <label>{{ language == 'en'? Doctor.employee?.department?.departmentName : Doctor.employee?.department?.departmentNameArabic }}</label>
                    </div>
                    <div class="col-lg-12" style="height: 30px;">
                        <a routerLink="/login" class="btn btn-primary" (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 
                    </div>
                </div>
                
            </div>
          <!-- <div *ngFor="let Doctor of SpecialtyDoctors;let i = index"
          class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
              <div class="doctor-item" (mouseenter)="OnMouseEnter(i)" (mouseleave)="OnMouseLeave(i)">
                  <div class="doctor-top" *ngIf="DoctorImg[i]" >
                      <img *ngIf="Doctor.picPath != null;else NoDocPic" [src]="Doctor.picPath | SafeImgUrlPipe" alt="Doctor">
                      <ng-template #NoDocPic><img src="assets/img/doctor/Avatar.png" alt="Doctor"></ng-template>
                      <a routerLink="/login" (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 
                  </div>
                  <div class="doctor-top" *ngIf="DoctorAbout[i]" >
                      <textarea style="border: none;height: 410px;display: flex;justify-content: center;align-items: center;" readonly class="form-control"  [value]=" language == 'en'?  Doctor.aboutEn : Doctor.aboutAr"></textarea>
                      <a routerLink="/login" (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 

                  </div>
                  <div class="doctor-bottom">
                      <h3 style="cursor:pointer;"><a (click)="GetAppointment(Doctor.employee?.departmentId,Doctor.employee?.empId)">
                          {{ language == 'en'? 'Dr. '+ Doctor.employee?.firstName +' ' + Doctor.employee?.middleName +' '+ Doctor.employee?.lastName
                          : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rMiddleName+' '+ Doctor.employee?.rLastName }}</a></h3>
                  </div>
              </div>
          </div> -->
          <!-- <div *ngFor="let Specialty of HospitalSpecialties" class="col-sm-6 col-lg-4"
            [routerLink]="'/portal/appointments/doctors/' + Specialty.departmentId" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" style="cursor:pointer;">
            <div class="department-item wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
              <h3> {{ language == 'en'? Specialty.departmentName: Specialty.departmentNameArabic }}</h3>
              <hr>
              <a *ngIf="Specialty.imagePath != null;else SpecialtyImagePath"><img
                  [src]="Specialty.imagePath | SafeImgUrlPipe" alt="Specialty" height="200px" width="200px"></a>
              <ng-template #SpecialtyImagePath><a><img style="transition :0.5s all ease !important"
                    src="assets/img/DefaultImage.png" alt="Specialty" height="250px" width="350px"></a></ng-template>
            </div>

          </div> -->

        </div>
      </div>
    </section>
  </div>
</div>